import { Sorts } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { ESortOrder } from "@domains/utils/sort";
// import { SORTFILTERTABS } from "./common/SortFilter";
var SORTFILTERTABS;
(function (SORTFILTERTABS) {
    SORTFILTERTABS["SORT"] = "SORT";
    SORTFILTERTABS["FILTER"] = "FILTER";
})(SORTFILTERTABS || (SORTFILTERTABS = {}));
export const FilterSortContent = [
    { title: "Sort", eventKey: SORTFILTERTABS.SORT },
    { title: "Filters", eventKey: SORTFILTERTABS.FILTER },
];
export var ISGBBuyType;
(function (ISGBBuyType) {
    ISGBBuyType["BUY"] = "buy";
    ISGBBuyType["MODIFY"] = "modify";
})(ISGBBuyType || (ISGBBuyType = {}));
export const sortlistorderbook = [
    new Sorts([
        {
            title: "Alphabetical",
            key: "issue",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Z to A", desc: "A to Z" },
            type: "string",
        },
        {
            title: "Amount",
            key: "totalValue",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Low to High", desc: "High to Low" },
            type: "number",
        },
        {
            title: "Order Date",
            key: "orderDate",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Older to Newer", desc: "Newer to Older" },
            type: "string",
        },
    ]),
];
export const orderbookFilters = [
    {
        filterName: "Action",
        eventKey: "trsTyp",
        list: [
            { title: "BUY", key: "BUY", selected: false },
            { title: "SELL", key: "SELL", selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: "Product Type",
        list: [
            { title: "CNC", key: "CNC", selected: false },
            { title: "NRML", key: "NRML", selected: false },
            { title: "MTF", key: "MTF", selected: false },
            { title: "MIS", key: "MIS", selected: false },
            { title: "BO", key: "BO", selected: false },
        ],
        selectType: "checkbox",
        eventKey: "prdCode",
    },
];
export const sgborderbookFilters = [
    {
        filterName: "Status",
        eventKey: "order",
        list: [
            // { title: "In process", key: "Inprocess", selected: false },
            { title: "Pending", key: "Pending", selected: false },
            { title: "Closed", key: "Closed", selected: false },
            { title: "Rejected", key: "Rejected", selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: "Order Date",
        list: [
            { title: "Last Month", key: "LastMonth", selected: false },
            { title: "Last 3 Months", key: "Last-3-Month", selected: false },
            { title: "Last 6 Months", key: "Last-6-Month", selected: false },
            {
                title: "Custom",
                key: "Custom",
                selected: false,
                customDateFilter: true,
            },
        ],
        selectType: "checkbox",
        eventKey: "orderDate",
        type: "Date",
    },
];
